/** Public community repo: importable content packs, example characters, the pack-writing skill, issues. */
export const CONTENT_REPO = 'https://gitlab.com/zookee1/charsmith-content-packs'
